import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import App from './App.jsx'
import { AuthProvider, useAuth } from './auth/AuthContext'
import LoginPage from './auth/LoginPage'
import LandingPage from './pages/LandingPage'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'
import ContactPage from './pages/ContactPage'
import DocsPage from './pages/DocsPage'
import PlanningChartPage from './pages/PlanningChartPage'
import RenkoRotationsPage from './pages/RenkoRotationsPage'
import ApiDocsPage from './pages/ApiDocsPage'

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/docs/:sectionId" element={<DocsPage />} />
        <Route path="/chart" element={<ProtectedRoute><App /></ProtectedRoute>} />
        <Route path="/chart/planning" element={<ProtectedRoute><PlanningChartPage /></ProtectedRoute>} />
        <Route path="/chart/renko" element={<ProtectedRoute><RenkoRotationsPage /></ProtectedRoute>} />
        <Route path="/chart/api-docs" element={<ProtectedRoute><ApiDocsPage /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  </BrowserRouter>,
)
